import { useSelector } from "react-redux";

// Whose mailbox the Messages screens show. As the Administrator it's the
// Admin account's own; in the header's "Learner" (View As) mode it's the
// picked person's - that's the only way to see a message the Admin sent
// arrive in someone's Inbox, since People have no login of their own.
// `query` goes on every /message/* call so the backend works on that same
// mailbox (see resolveMailbox in the message handler).
const useMailbox = () => {
  const role = useSelector((state) => state.systemTracking.role);
  const viewingAsPeopleId = useSelector((state) => state.systemTracking.viewingAsPeopleId);

  const isPersonView = role === "Learner";
  const peopleId = isPersonView ? viewingAsPeopleId : null;

  return {
    isPersonView,
    peopleId,
    // Learner mode with nobody picked yet - there's no mailbox to show.
    needsPerson: isPersonView && !viewingAsPeopleId,
    query: peopleId ? `?people_id=${encodeURIComponent(peopleId)}` : "",
  };
};

export default useMailbox;
